import { useContext } from 'react';
import UserContext from './UserProvider';

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};
